var map = {
	"./Artificial-Insemination.jpg": 7761,
	"./Cooling-System.jpg": 1201,
	"./Diet.jpg": 2126,
	"./Medical.jpg": 9339,
	"./Others.jpg": 7401,
	"./Thermal.jpg": 5047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3399;